import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import logo from "../assets/Light.png";

const missions = [
  { label: "Branding", path: "/branding" },
  { label: "UI/UX", path: "/ui-ux" },
  { label: "SEO & GEO", path: "/seo-geo" },
  // { label: "Marketing", path: "#" },
  { label: "Production & Post-production", path: "/production-post-production" },
];

export default function Header({ visible = true }) {
  const navigate = useNavigate();
  const location = useLocation();
  const navRef = useRef(null);
  const [missionsOpen, setMissionsOpen] = useState(false);

  const closeMenu = () => {
    setMissionsOpen(false);
    document.body.style.overflow = "";
    if (navRef.current?.classList.contains("show")) {
      navRef.current.classList.remove("show");
    }
  };

  // close dropdown & drawer on route change
  useEffect(() => {
    closeMenu();
  }, [location.pathname]);

  if (!visible) return null;

  const go = (path) => {
    navigate(path);
    closeMenu();
  };

  const toggleMobileNav = () => {
    const isCurrentlyOpen = navRef.current?.classList.contains("show");
    if (isCurrentlyOpen) {
      closeMenu();
    } else {
      document.body.style.overflow = "hidden";
      if (navRef.current) {
        navRef.current.classList.add("show");
      }
    }
  };

  return (
    <nav className="nav-top show-top">
      <div className="navbar navbar-expand-lg w-100">
        <div className="container-fluid">

          {/* LOGO */}
          <span className="navbar-brand" onClick={() => go("/")}>
            <img src={logo} className="logo" alt="logo" />
          </span>

          {/* TOGGLER */}
          <button
            className="navbar-toggler"
            type="button"
            aria-label="Toggle navigation"
            onClick={toggleMobileNav}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* NAV COLLAPSE / OVERLAY */}
          <div className="collapse navbar-collapse" id="mainNavbar" ref={navRef}>
            {/* CLOSE BUTTON FOR MOBILE DRAWER */}
            <div className="mobile-close-wrapper d-lg-none">
              <button
                type="button"
                className="mobile-close-btn"
                aria-label="Close menu"
                onClick={closeMenu}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </div>

            <ul className="navbar-nav ms-auto mobile-nav">

              <li className="nav-item">
                <button className="nav-link" onClick={() => go("/about")}>
                  About
                </button>
              </li>

              {/* SERVICES / MISSIONS */}
              <li className={`nav-item missions ${missionsOpen ? "open" : ""}`}>
                <div className="missions-header-row">
                  {/* TEXT → NAVIGATE */}
                  <button
                    type="button"
                    className="nav-link missions-label"
                    onClick={() => go("/services")}
                  >
                    Services
                  </button>

                  {/* ICON → TOGGLE */}
                  <button
                    type="button"
                    className="missions-icon"
                    aria-label="Toggle services menu"
                    onClick={(e) => {
                      e.stopPropagation();
                      setMissionsOpen((v) => !v);
                    }}
                  >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path
                        d="M6 9l6 6 6-6"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                </div>

                <div className="missions-dropdown">
                  {missions.map((m) => (
                    <button
                      key={m.path}
                      type="button"
                      className="dropdown-link"
                      onClick={() => go(m.path)}
                    >
                      {m.label}
                    </button>
                  ))}
                </div>
              </li>

              <li className="nav-item">
                <button className="nav-link" onClick={() => go("/blogs")}>
                  Blogs
                </button>
              </li>

              <li className="nav-item">
                <button className="nav-link" onClick={() => go("/contact")}>
                  Contact
                </button>
              </li>

            </ul>
          </div>

        </div>
      </div>
    </nav>
  );
}
